import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_PRODUCTS;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_post_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}


function import_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-line-excel", param);
}

function import_service_line_excel(param = {}) {
  return wsService.make_post_request(section + "/import-service-line-excel", param);
}

export const productService = {
  section,
  filter,
  remove,
  create,
  update,
  import_line_excel,
  import_service_line_excel,
};
